<template>
  <MultipleSelector
    :buttonText="$t('multiple_selector.add_team')"
    :label="$t('common.team_other')"
    :options="teamOptions"
    :selectionLimit="15"
    :value="value"
    :disabled="disabled"
    :loading="loading"
    :type="$t('common.team_other')"
    :zIndex="zIndex"
    @change="$emit('change', $event)"
    @search="searchTeams"
  />
</template>

<script>
import { mapGetters } from 'vuex'

import api from '@/api'
import mixin from '@/mixins/mixin.vue'

import MultipleSelector from '@/components/MultipleSelector/MultipleSelector.vue'

const ITEMS_PER_PAGE = 30

export default {
  name: 'MultipleTeamSelector',

  mixins: [mixin],

  components: {
    MultipleSelector,
  },

  props: {
    disabled: Boolean,
    value: Array,
    zIndex: Number,
  },

  data() {
    return {
      loading: false,
      availableTeams: [],
      page: 0,
      terms: null,
    }
  },

  async mounted() {
    await this.fetchInitialTeams()
    await this.searchTeams()
  },

  computed: {
    ...mapGetters(['organizationId']),

    teamOptions() {
      return this.availableTeams.map(team => {
        return {
          ...team,
          icon: 'mdi-account-group',
          title: team.name,
          subtitle: this.$t('multiple_selector.team_members_count', {
            count: team?.members?.length ?? team?.membersCount ?? 0,
          }),
        }
      })
    },
  },

  methods: {
    async searchTeams(terms = '') {
      try {
        this.terms = terms
        this.loading = true

        const response = await api.teams.getTeamsStream(this.organizationId, {
          limit: ITEMS_PER_PAGE,
          terms,
          sort: {
            by: terms?.length ? '_score' : 'name',
            order: terms?.length ? 'desc' : 'asc',
          },
        })

        const fetchedTeams =
          response?.data?.results.map(result => result.team) ?? []

        this.availableTeams = [...fetchedTeams]
      } catch (err) {
        this.handleRequestError(err)
      } finally {
        this.loading = false
      }
    },

    async fetchInitialTeams() {
      try {
        this.loading = true
        const from = ITEMS_PER_PAGE * 0
        const response = await api.teams.getTeamsStream(this.organizationId, {
          filters: { ids: this.value },
          from,
          sort: { by: 'name', order: 'asc' },
        })
        const fetchedTeams =
          response?.data?.results.map(result => result.team) ?? []
        this.availableTeams = [...fetchedTeams]
      } catch (err) {
        this.handleRequestError(err)
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
